import { twMerge } from "tailwind-merge";

import SubVisual from "../common/SubVisual";

interface SubLayoutProps {
    children: React.ReactNode;
    className?: string;
}

export default function SubLayout({ children, className }: SubLayoutProps) {
    return (
        <>
            <SubVisual />
            <div
                className={twMerge(
                    "relative pt-[40px] before:content-[''] before:absolute before:left-0 before:top-[1px] before:w-[50px] before:h-[50px] before:border-[25px] before:border-white before:border-t-transparent before:border-r-transparent before:-translate-y-full xl:pt-[80px] md:before:w-[120px] md:before:h-[120px] md:before:border-[60px]",
                    className,
                )}
            >
                {children}
            </div>
        </>
    );
}
